// extracted by mini-css-extract-plugin
export default {"widgetPaper":"styles_widgetPaper__3xspS","widgetContent":"styles_widgetContent__atY7L","text":"styles_text__5W+MM"};